export const getInitials = (name?: string) => {
  if (!name || typeof name !== "string") return "";
  const names = name.split(" ");
  const initials = names.map((n) => n[0]).join("");
  return initials.toUpperCase();
};
